import React from 'react'
import { createPortal } from 'react-dom'
import { Rnd } from 'react-rnd'
import styled from 'styled-components'

import { FormState } from '../Form'

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9000;
`

const Inner = styled.div`
  overflow-y: auto;
  max-height: 500px;
  min-height: 500px;
  max-width: 500px;
  box-shadow: 0px 0px 10px 5px rgba(0, 0, 0, 0.75);
  background: white;
`

export type TFormStateWindow = {
  expanded?: boolean
  limitToPath?: string
  defaultPositionAndSize?: {
    x: number
    y: number
    width: number
    height: number
  }
}

const FormStateWindow = (props: TFormStateWindow): React.ReactElement => {
  const { expanded, limitToPath, defaultPositionAndSize } = props

  return createPortal(
    <Wrapper>
      <Rnd
        default={
          defaultPositionAndSize ?? {
            x: 500,
            y: 0,
            width: 500,
            height: 500,
          }
        }
        bounds="window"
      >
        <Inner>
          <FormState expanded={expanded} limitToPath={limitToPath} />
        </Inner>
      </Rnd>
    </Wrapper>,
    document.body,
  )
}

export default FormStateWindow
